<div class="form-templates">
  <a
    (click)="kakaotalkTemplatesService.navigateToList()"
    class="arrow arrow-left"
    [translate]="'parameters/kakaotalk-templates/details/back'"></a>

  <mat-card>
    <mat-card-title translate="parameters/kakaotalk-templates/details/main/title"></mat-card-title>
    <mat-card-subtitle>
      <span translate="parameters/kakaotalk-templates/description-1"></span><br />
    </mat-card-subtitle>
    <mat-card-content>
      <app-kakaotalk-template-main [form]="mainForm" [template]="template"></app-kakaotalk-template-main>
    </mat-card-content>
  </mat-card>

  <mat-card>
    <mat-card-title translate="parameters/kakaotalk-templates/details/category/title"></mat-card-title>
    <mat-card-content>
      <app-kakaotalk-template-category [form]="form"></app-kakaotalk-template-category>
    </mat-card-content>
  </mat-card>

  <ng-container
    *ngIf="
      form.get('main').get('languages')?.value.length &&
      form.get('main').get('languages').value[0] &&
      templatesLanguageActive?.length
    ">
    <mat-tab-group mat-stretch-tabs="false" mat-align-tabs="start" (selectedTabChange)="selectedIndexChange($event)">
      <ng-container *ngFor="let templateControl of templatesLanguageActive">
        <mat-tab>
          <ng-template matTabLabel><span [translate]="templateControl.get('code').value"></span></ng-template>
          <app-kakaotalk-template-languages
            [form]="templateControl"
            [template]="template"></app-kakaotalk-template-languages>
        </mat-tab>
      </ng-container>
    </mat-tab-group>
  </ng-container>
</div>
<div class="message-preview">
  <app-kakaotalk-template-preview
    [templateDisplayedBS]="templateDisplayedBS"
    [settingsMode]="true"></app-kakaotalk-template-preview>
</div>
